import { h } from 'preact'
import { baseUrl } from '../pmd/pmd-urls'
import styles from './index.module.css'

export function Mur() {
  return (
    <figure className={styles.mur}>
      <img
        src={`${baseUrl}test/wire_crop-2400.jpg`}
        alt="Illustrasjon av muren rundt koranskolen, med piggtråd og glassskår på toppen."
      />
    </figure>
  )
}
